import { useQuery } from 'react-query';

import { getTemplateRelatedProjects as queryFn } from 'api/endPoints/getTemplateRelatedProjects';
import { QueryKeys } from 'api/queryKeys';

import { IPhasePerformanceContracts } from 'components/widgets/PhasePerformanceChart/PhasePerformance.types';

export const useQueryPhasePerformanceGetTemplateRelatedProjects = (params: QueryParams) => {
    return useQuery<QueryFnResponse[], QueryError, QueryResponse[], [QueryKeys, unknown]>({
        queryKey: ['getTemplateRelatedProjects', params],
        queryFn: () => queryFn(params),
        enabled: Boolean(params.templateId),
    });
};

export interface QueryParams {
    templateId?: string | number | null;
}

export type QueryFnResponse = IPhasePerformanceContracts;

type QueryResponse = QueryFnResponse & {};
